/* eslint-disable no-undef */
import { ALERT_EXPORT_ALLOTMENT_NODES } from './delivrablesWidgetsConfig';
import './deliverablesWidget.scss';
import { ProjectDTO } from '../../../../../models/ProjectDTO';
import { SheetDTO, checkRseeDataForExport } from '../exportRsee/RseeDataValidation';
import { StateDTO } from '../../../../models/GeneralDTO';
import {
  TYPE_EPCM,
  TYPE_RE2020,
  TYPE_GLOBAL_MONITORING,
} from '../../../../globalVariable/typeProject';
import { useDispatch, useSelector } from 'react-redux';
import { zonesDTO } from '../WidgetsDTO';
import React, { useRef, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';
import {
  ProjectVerificationLevel,
  Widgets,
} from '@photocarbone/nooco-shared-api-def';
import VerificationModal from './VerificationModal';
import { Button, FullScreenModal } from '@photocarbone/nooco-ui';
import PdfBuilder from '../../../PdfBuilder';
import notesAdd from '../../../../../assets/images/pdfbuilder/note-add.png';
import { DeliverablesComponent } from '@photocarbone/nooco-ui';
import { Button as ButtonAnt, Alert } from 'antd';
import { updateCheckValue } from '../../../../../actions/report';
import API from '../../../../services/API';
import { areArraysEqual } from '../../../../shared/utilsFunction';

type DeliverablesWidgetsProps = {
  rseeText: string;
  seuilsOk: boolean;
  downloadPdf: boolean;
  setDownloadPdf: Function;
  generatePDF: Function;
  zones: zonesDTO[];
  downloadRsee: boolean;
  generateRsee: Function;
  currentProject: ProjectDTO;
  setShow: Function;
  isExportEpcmDateValid: boolean;
  getRseePdf: Function;
};

type rseeExportClicableIconProps = {
  downloadRseeXml: boolean;
  generateRsee: Function;
  licenceTypeAccess: string;
  seuilsOk: boolean;
  zones: zonesDTO[];
  isExportEpcmDateValid: boolean;
  rseeText: string;
  currentProject: ProjectDTO;
  setShow: Function;
  setIsVerificationModalOpen: Function;
  getAllotmentNodesWithUnitWarning: Object[];
  isProjectEpcm: boolean;
  setIsXml: Function;
};

const api = new API();

const pdfExportClicableIcon = (
  downloadPdf: boolean,
  setDownloadPdf: Function,
  generatePDF: Function,
  isEnglishLanguage: boolean
) => {
  !downloadPdf && !isEnglishLanguage
    ? (setDownloadPdf(true), generatePDF())
    : undefined;
};

const getAccessRightForButton = (
  licenceType: string,
  sheets: SheetDTO[],
  verificationData: ProjectVerificationLevel,
  rseeText: string,
  zones?: zonesDTO[],
  validThresholds?: boolean,
  isExportEpcmDateValid?: boolean,
  projectType?: string
): [boolean, string] => {
  let tooltipText = '';
  let isButtonUsable = true;
  const { t } = useTranslation();

  if (licenceType !== 'pro') {
    tooltipText = t('APP.WIDGETS.DELIVERABLESWIDGETS.PH_0DC7FE', {
      defaultValue: 'Fonctionnalité disponible avec une licence pro seulement',
    });
    isButtonUsable = false;
  } else {
    [isButtonUsable, tooltipText] = checkRseeDataForExport(
      sheets,
      verificationData,
      rseeText,
      zones,
      validThresholds,
      isExportEpcmDateValid,
      projectType
    );
  }

  return [isButtonUsable, tooltipText];
};

const rseeExportPdfClicableIcon = (
  loaderPdf,
  licenceTypeAccess,
  seuilsOk,
  zones,
  isExportEpcmDateValid,
  rseeText,
  currentProject,
  getRseePdf,
  setIsVerificationModalOpen,
  getAllotmentNodesWithUnitWarning,
  isProjectEpcm,
  setIsXml
) => {
  const { t } = useTranslation();

  const [isRseeExportable, tooltipText] = getAccessRightForButton(
    licenceTypeAccess,
    currentProject.Sheets,
    currentProject.VerificationData,
    rseeText,
    zones,
    seuilsOk,
    isExportEpcmDateValid,
    currentProject.templateType
  );

  if (isProjectEpcm) {
    return (
      <Tooltip
        title={t('APP.WIDGETS.DELIVERABLESWIDGETS.PH_20C0E8', {
          defaultValue:
            'Lien vers la plateforme qui vous permet de télécharger votre RSEE au format PDF',
        })}
      >
        <ButtonAnt
          disabled={!isRseeExportable || loaderPdf}
          className="button__style"
          onClick={() => {
            setIsXml(false);
            if (getAllotmentNodesWithUnitWarning.length > 0) {
              setIsVerificationModalOpen(true);
            } else {
              window.location.href =
                'http://observatoire.batiment-energiecarbone.fr/authentification/connexion/';
            }
          }}
        >
          {t('APP.VIGNETTE.DELIVERABLES.MENUITEM.PDFRSEE', {
            defaultValue: 'Télécharger le PDF du RSEE',
          })}
        </ButtonAnt>
      </Tooltip>
    );
  } else {
    return (
      <Tooltip title={tooltipText}>
        <ButtonAnt
          disabled={!isRseeExportable || loaderPdf}
          className="button__style"
          onClick={() => {
            setIsXml(false);
            if (getAllotmentNodesWithUnitWarning.length > 0) {
              setIsVerificationModalOpen(true);
            } else {
              if (isRseeExportable && currentProject.isRset) {
                if (!isProjectEpcm) {
                  getRseePdf(currentProject.id);
                }
              }
            }
          }}
        >
          {t('APP.VIGNETTE.DELIVERABLES.MENUITEM.PDFRSEE', {
            defaultValue: 'Télécharger le PDF du RSEE',
          })}
        </ButtonAnt>
      </Tooltip>
    );
  }
};

const RseeExportClicableIcon = ({
  downloadRseeXml,
  generateRsee,
  licenceTypeAccess,
  seuilsOk,
  zones,
  isExportEpcmDateValid,
  rseeText,
  currentProject,
  setShow,
  setIsVerificationModalOpen,
  getAllotmentNodesWithUnitWarning,
  isProjectEpcm,
  setIsXml,
}: rseeExportClicableIconProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const isEnglishLanguage = i18n.language !== 'fr-FR';

  const [isRseeExportable, tooltipText] = getAccessRightForButton(
    licenceTypeAccess,
    currentProject.Sheets,
    currentProject.VerificationData,
    rseeText,
    zones,
    seuilsOk,
    isExportEpcmDateValid,
    currentProject.templateType
  );

  return (
    <Tooltip title={isEnglishLanguage ? 'Soon Available' : tooltipText}>
      <ButtonAnt
        disabled={isEnglishLanguage || downloadRseeXml || !isRseeExportable}
        onClick={() => {
          setIsXml(true);
          isRseeExportable && !isEnglishLanguage
            ? isProjectEpcm
              ? getAllotmentNodesWithUnitWarning.length > 0
                ? setIsVerificationModalOpen(true)
                : setShow(true)
              : getAllotmentNodesWithUnitWarning.length > 0
              ? setIsVerificationModalOpen(true)
              : generateRsee(currentProject.id, currentProject.name)
            : undefined;
        }}
        className="button__style"
      >
        {t('APP.VIGNETTE.DELIVERABLES.MENUITEM.XMLRSEE', {
          defaultValue: 'Télécharger le XML du RSEE',
        })}
      </ButtonAnt>
    </Tooltip>
  );
};

const DeliverablesWidgets = ({
  rseeText,
  seuilsOk,
  downloadPdf,
  setDownloadPdf,
  generatePDF,
  zones,
  downloadRsee,
  generateRsee,
  currentProject,
  setShow,
  isExportEpcmDateValid,
  getRseePdf,
}: DeliverablesWidgetsProps): JSX.Element => {
  const isProjectEpcm = currentProject.templateType === TYPE_EPCM;

  const { licenceTypeAccess, loaderPdf, isSuperAdmin } = useSelector(
    (state: StateDTO) => state.projects
  );
  const { pdfDocumentId, openPdfBuilder, widgetsInDropZone } = useSelector(
    (state: StateDTO) => state.report
  );
  const [isDownloadPdf, setIsDownloadPdf] = useState(false);

  const dispatch = useDispatch();
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);
  const isProjectTypeRsenvCompatible =
    currentProject.templateType === TYPE_RE2020 ||
    currentProject.templateType === TYPE_EPCM;
  const [isXml, setIsXml] = useState(false);
  const { t, i18n } = useTranslation();
  const isEnglishLanguage = i18n.language === 'en-GB';
  const widgetsRef = useRef();

  const tooltipText = isEnglishLanguage
    ? t('APP.RIGHTS.RIGHTS.PH_65A3E8', {
        defaultValue: 'Bientôt disponible',
      })
    : t('APP.WIDGETS.DELIVERABLESWIDGETS.PH_699635', {
        defaultValue: 'Télécharger une synthèse du projet au format pdf',
      });

  const getAllotmentNodesWithUnitWarning = () => {
    let allotmentNodesList = [];

    currentProject?.Sheets.forEach((sheet) => {
      sheet?.AllotmentNodes.forEach((allotmentsNode) => {
        if (ALERT_EXPORT_ALLOTMENT_NODES.includes(allotmentsNode.id)) {
          const exists = allotmentNodesList.find(
            (allotmentNode) => allotmentNode.id === allotmentsNode.id
          );
          if (!exists) allotmentNodesList.push(allotmentsNode);
        }
      });
    });

    return allotmentNodesList;
  };

  const renderPdfButtons = () => (
    <div className="footer-modal-pdf-builder">
      <Button
        className="close-button"
        text={t('APP.FULLSCREENMODAL.CLOSE', { defaultValue: 'Fermer' })}
        onClick={() => dispatch(updateCheckValue('openPdfBuilder', false))}
        style={{ marginRight: '10px' }}
      />
      <Button
        className="purple-button"
        text={t('APP.FULLSCREENMODAL.DOWNLOAD', {
          defaultValue: 'Télécharger',
        })}
        loading={isDownloadPdf}
        disabled={!Boolean(pdfDocumentId)}
        onClick={() => {
          downloadPdfFromBuilder(pdfDocumentId);
        }}
      />
    </div>
  );

  const downloadPdfFromBuilder = async (documentId: string) => {
    const getDocument = async (documentId: string) => {
      setIsDownloadPdf(true);
      const responsePdf = await api.getPdfDownloadUrl(currentProject.id, documentId);
      return responsePdf.data;
    };

    const pdfData = await getDocument(documentId);
    const response = await fetch(pdfData.download_url);
    const localPdfData = await response.blob();
    const localPdfUrl = window.URL.createObjectURL(localPdfData);

    const link = document.createElement('a');
    link.href = localPdfUrl;
    link.target = '_blank';
    link.download = `${currentProject.name}_Nooco.pdf`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(localPdfUrl);
    setIsDownloadPdf(false);
  };

  function isPdfOutdatedRelatedToDropZone(
    widgetsRef: React.MutableRefObject<undefined>,
    pdfDocumentId: string,
    widgetsInDropZone: Widgets[]
  ) {
    return (
      widgetsRef.current &&
      pdfDocumentId &&
      !areArraysEqual(widgetsRef.current, widgetsInDropZone)
    );
  }

  return (
    <div className="report-rsee-download ">
      <FullScreenModal
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ display: 'flex', padding: '0.1em' }}>
              <div className="icon-header-pdf-builder-modal">
                <img style={{ width: '22px' }} src={notesAdd} />
              </div>
              <p className="title-section">Téléchargement du PDF de la synthèse</p>
            </div>
            <div style={{ marginRight: '3%' }}>
              {isPdfOutdatedRelatedToDropZone(
                widgetsRef,
                pdfDocumentId,
                widgetsInDropZone
              ) && (
                <>
                  {' '}
                  <Alert
                    showIcon
                    message={
                      <p style={{ margin: 0 }}>
                        {t('APP.DELIVERABLES_WIDGETS.NEED_REFRESH_ON_PDF_BUILDER', {
                          defaultValue:
                            "La prévisualisation n'est plus à jour, veuillez la rafraîchir",
                        })}
                      </p>
                    }
                    type="warning"
                  />
                </>
              )}
            </div>
          </div>
        }
        bodyContent={<PdfBuilder widgetsRef={widgetsRef} />}
        openModal={openPdfBuilder}
        setOpenModal={(value) => dispatch(updateCheckValue('openPdfBuilder', value))}
        needCustomFooter={() => renderPdfButtons()}
      />
      <VerificationModal
        allotmentNodes={getAllotmentNodesWithUnitWarning()}
        isOpen={isVerificationModalOpen}
        setIsOpen={setIsVerificationModalOpen}
        getRseePdf={getRseePdf}
        id={currentProject.id}
        name={currentProject.name}
        isProjectEpcm={isProjectEpcm}
        isXml={isXml}
        setShow={setShow}
        generateRsee={generateRsee}
      />
      <DeliverablesComponent
        style={{ marginTop: 5, width: '100%', height: '100%', background: 'none' }}
      >
        <>
          <ButtonAnt
            className="button__style"
            onClick={() => dispatch(updateCheckValue('openPdfBuilder', true))}
          >
            {t('APP.VIGNETTE.DELIVERABLES.MENUITEM.PDFSYNTHESE', {
              defaultValue: 'Télécharger le PDF de la Synthèse',
            })}
          </ButtonAnt>

          {isProjectTypeRsenvCompatible && (
            <>
              {rseeExportPdfClicableIcon(
                loaderPdf,
                licenceTypeAccess,
                seuilsOk,
                zones,
                isExportEpcmDateValid,
                rseeText,
                currentProject,
                getRseePdf,
                setIsVerificationModalOpen,
                getAllotmentNodesWithUnitWarning(),
                isProjectEpcm,
                setIsXml
              )}
              {RseeExportClicableIcon({
                downloadRseeXml: downloadRsee,
                generateRsee,
                licenceTypeAccess,
                seuilsOk,
                zones,
                isExportEpcmDateValid,
                rseeText,
                currentProject,
                setShow,
                setIsVerificationModalOpen,
                getAllotmentNodesWithUnitWarning: getAllotmentNodesWithUnitWarning(),
                isProjectEpcm,
                setIsXml,
              })}
            </>
          )}
        </>
      </DeliverablesComponent>
    </div>
  );
};

export default DeliverablesWidgets;
